import { TypePolicy } from '@apollo/client'
export const productFamilyTypePolicy = {
    ProductFamily: {
        keyFields: false,
    } as TypePolicy,
}
